import { createStore, applyMiddleware, compose } from 'redux';
import { createLogger } from 'redux-logger';
import thunkMiddleware from 'redux-thunk';
import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import createRootReducer from '../reducers';
import { isEmpty } from 'lodash';

import { createCookie } from '../utils/cookie'
import { USER_FILTER_STATE, USER_FILTER_STATE_DURATION, USER_FILTER_STATE_PATH } from '../constants/filter';


export const history = createBrowserHistory();

const loggerMiddleware = createLogger({
  level: 'info',
  collapsed: true,
});

const isDevelopmentMode = process.env.NODE_ENV !== 'production';

export default function configureStore(initialState, enableLogger = true) {
  // initialState = JSON.parse(window.localStorage.getItem('state')) || initialState;
  const headerState = window.localStorage
    && window.localStorage.getItem('publish')
    && JSON.parse(window.localStorage.getItem('publish'));

  const store = createStore(
    createRootReducer(history),
    initialState,
    compose(
      applyMiddleware(
        thunkMiddleware,
        routerMiddleware(history),
        ...(isDevelopmentMode && enableLogger ? [
          loggerMiddleware,
        ] : []),
      ),
      ...(isDevelopmentMode
        && window.__REDUX_DEVTOOLS_EXTENSION__ ? [ window.__REDUX_DEVTOOLS_EXTENSION__() ] : []),
    ),
  );

  store.subscribe(() => {
    const persist = {
      services: headerState && headerState.services,
      headerServices: headerState && headerState.headerServices,
      headerSettings: headerState && headerState.headerSettings,
      navigation: headerState && headerState.navigation,
      headerNavigation: headerState && headerState.headerNavigation,
    };

    if (window.localStorage) { window.localStorage.setItem('state', JSON.stringify(persist)); }
    const {
      filterState: filterStateVal,
    } = store.getState();
    if (!isEmpty(filterStateVal.f)) {
      createCookie(USER_FILTER_STATE, JSON.stringify(filterStateVal),
        USER_FILTER_STATE_DURATION, USER_FILTER_STATE_PATH);
    }
  });
  return store;
}
